import "core-js/modules/web.dom-collections.iterator.js";
import React, { useEffect, useMemo, useState } from 'react';
import { ErrorCard } from '@eika/card';
import restClient from '../../restClient';
import OverlayLoader from '../overlay-loader';
/**
 * Typical flow:
 * 1. visit this section
 * 2. call "start signing"
 * 3. receive redirect url to Nets
 * 4. Nets redirects back to kyc?task=..., and we remember the customers position in the form (this section). This work
 * poorly locally, since you'll be redirected to test-environment
 * 5. call "start signing" again
 * 6. receive completed timestamp
 * 7. call afterSigning to send customer to next page
 */
const TaxSigning = _ref => {
  let {
    afterSigning
  } = _ref;
  const [startedSigning, setStartedSigning] = useState();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  useMemo(() => {
    setLoading(true);
    setError(false);
    restClient.startSigning().then(value => {
      setStartedSigning(() => value);
      setLoading(false);
      setError(false);
    }).catch(() => {
      setLoading(false);
      setError(true);
    });
  }, []);
  useEffect(() => {
    if (startedSigning !== null && startedSigning !== void 0 && startedSigning.url) {
      window.location.href = startedSigning.url;
    }
  }, [afterSigning, startedSigning === null || startedSigning === void 0 ? void 0 : startedSigning.url]);
  useEffect(() => {
    if (startedSigning !== null && startedSigning !== void 0 && startedSigning.completed) {
      afterSigning();
    }
  }, [afterSigning, startedSigning === null || startedSigning === void 0 ? void 0 : startedSigning.completed]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, loading && /*#__PURE__*/React.createElement(OverlayLoader, null), error && /*#__PURE__*/React.createElement(ErrorCard, {
    title: "Noe gikk galt!",
    description: "Vi kunne ikke lagre svarene dine. Vennligst pr\xF8v igjen senere eller kontakt banken dersom problemene vedvarer"
  }));
};
export default TaxSigning;